import React, { Fragment } from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import TextField from "../text-field"
import Label from "../label"

const MultiTextField = ({ handleInputChange, name, value, options, simpleForm }) => {
  const onChange = (eName, eValue) => {
    let valueHash = {}
    if (typeof value === "object") valueHash = value
    valueHash[eName] = eValue
    if (handleInputChange !== undefined) handleInputChange(name, valueHash)
  }

  const getValue = (name) => {
    if (typeof value === "object") return value[name]
    else return ""
  }

  return (
    <Grid gap="1rem" style={{ marginBottom: "1rem" }}>
      {options.map((option, index) => (
        <Grid gap="0" key={`${option[0]}_${index}`}>
          <Label marginless simpleForm={simpleForm}>
            {option[1]}
          </Label>
          <TextField
            handleInputChange={onChange}
            id={`${option[0]}_${index}`}
            value={getValue(option[0])}
            name={option[0]}
            simpleForm={simpleForm}
          />
        </Grid>
      ))}
    </Grid>
  )
}

MultiTextField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  value: PropTypes.object,
  handleInputChange: PropTypes.func.isRequired
}

MultiTextField.defaultProps = {
  name: "",
  options: [],
  value: {},
  handleInputChange: undefined
}

export default MultiTextField
